var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetails01 = function SvgDetails01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 32.93,
    y1: 181.87,
    x2: 174.86,
    y2: 37.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 14.66,
    y1: 163.95,
    x2: 156.59,
    y2: 19.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 48.45,
    y1: 197.08,
    x2: 190.38,
    y2: 52.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.38,
    y1: 145.28,
    x2: 137.55,
    y2: 0.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 29.41,
    y1: 178.41,
    x2: 171.34,
    y2: 33.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 33.71,
    y1: 182.62,
    x2: 175.64,
    y2: 37.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 67.49,
    y1: 215.75,
    x2: 209.42,
    y2: 71,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.57,26.2h-18.09v-8.09c0-2.62-2.86-3.81-5.48-3.81h-14.05C117.62,4.78,109.29.02,99.76.02c-9.42-.35-17.98,5.42-21.19,14.28h-13.81c-2.62,0-5.24,1.19-5.24,3.81v8.09h-18.09c-10.72.11-19.49,8.57-20,19.28v136.42c0,10.48,9.52,18.09,20,18.09h117.13c10.48,0,20-7.62,20-18.09V45.49c-.5-10.71-9.28-19.17-20-19.28ZM69.05,23.82h13.09c2.29-.28,4.12-2.02,4.52-4.29,1.41-6.14,6.8-10.55,13.09-10.71,6.24.19,11.55,4.61,12.86,10.71.43,2.35,2.38,4.11,4.76,4.29h13.57v19.05h-61.9v-19.05ZM158.57,190.48H41.43c-5.24,0-10.48-3.33-10.48-8.57V45.49c.49-5.45,5-9.66,10.48-9.76h18.09v12.14c.25,2.67,2.56,4.66,5.24,4.52h70.23c2.73.15,5.11-1.82,5.48-4.52v-12.14h18.09c5.47.1,9.99,4.31,10.48,9.76v136.42h0c0,5.24-5.24,8.57-10.48,8.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.67,106.44c-1.79-1.88-4.75-1.99-6.67-.24l-15.24,14.52-6.43-6.67c-1.79-1.88-4.75-1.99-6.67-.24-1.84,1.93-1.84,4.97,0,6.9l9.76,10c.84.95,2.07,1.47,3.33,1.43,1.26-.02,2.45-.53,3.33-1.43l18.57-17.62c1.84-1.69,1.96-4.55.27-6.39-.09-.1-.18-.19-.27-.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150,116.67h-54.76c-2.63,0-4.76,2.13-4.76,4.76s2.13,4.76,4.76,4.76h54.76c2.63,0,4.76-2.13,4.76-4.76s-2.13-4.76-4.76-4.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.67,68.34c-1.79-1.88-4.75-1.99-6.67-.24l-15.24,14.52-6.43-6.67c-1.79-1.88-4.75-1.99-6.67-.24-1.84,1.93-1.84,4.97,0,6.9l9.76,10c.84.95,2.07,1.47,3.33,1.43,1.26-.02,2.45-.53,3.33-1.43l18.57-17.62c1.84-1.69,1.96-4.55.27-6.39-.09-.1-.18-.19-.27-.28Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150,78.58h-54.76c-2.63,0-4.76,2.13-4.76,4.76s2.13,4.76,4.76,4.76h54.76c2.63,0,4.76-2.13,4.76-4.76s-2.13-4.76-4.76-4.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.67,144.53c-1.79-1.88-4.75-1.99-6.67-.24l-15.24,14.52-6.43-6.67c-1.79-1.88-4.75-1.99-6.67-.24-1.84,1.93-1.84,4.97,0,6.9l9.76,10c.84.95,2.07,1.47,3.33,1.43,1.26-.02,2.45-.53,3.33-1.43l18.57-17.62c1.84-1.69,1.96-4.55.27-6.39-.09-.1-.18-.19-.27-.28Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150,154.77h-54.76c-2.63,0-4.76,2.13-4.76,4.76s2.13,4.76,4.76,4.76h54.76c2.63,0,4.76-2.13,4.76-4.76s-2.13-4.76-4.76-4.76Z"
  })));
};
export default SvgDetails01;